export const state = {
  alertConditionCats: [],
};

export type State = typeof state;
